import { Grid, Typography } from "@mui/material";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import PieChartIcon from "@mui/icons-material/PieChart";
import BarChartIcon from "@mui/icons-material/BarChart";

import TableChartIcon from "@mui/icons-material/TableChart";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import React, { FunctionComponent } from "react";
import { VizType } from "../../../models/Reporting/ReportModel";

interface OwnProps {
    vizType?: VizType;
    parentHeightPx: number;
}

type Props = OwnProps;

const EmptyReportIndicator: FunctionComponent<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = (props) => {
    function getIcon(vizType?: VizType) {
        const iconSx = {
            color: "text.disabled",
            opacity: 0.35,
            fontSize: `${props.parentHeightPx * 0.42}px`,
        };
        if (vizType === VizType.Line) {
            return <TrendingUpIcon sx={iconSx} />;
        } else if (vizType === VizType.Bar) {
            return <EqualizerIcon sx={iconSx} />;
        } else if (vizType === VizType.Table) {
            return <TableChartIcon sx={iconSx} />;
        } else if (vizType === VizType.Pie) {
            return <PieChartIcon sx={iconSx} />;
        } else if (vizType === VizType.Histogram) {
            return <BarChartIcon sx={iconSx} />;
        }
        return "";
    }

    return (
        <>
            {props.vizType !== undefined && (
                <div style={{ position: "relative", top: `20%` }}>
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                            position: "relative",
                            width: "100%",
                            height: "100%",
                        }}
                    >
                        <Grid item xs={12}>
                            {getIcon(props.vizType)}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                sx={{
                                    opacity: 0.25,
                                    color: "#1F1F1F",
                                    fontSize:
                                        props.parentHeightPx > 450
                                            ? "24px"
                                            : "18px",
                                    fontWeight: "bold",
                                    letterSpacing: "0",
                                    lineHeight: "20px",
                                }}
                            >
                                No data available for applied filters
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            )}
        </>
    );
};

export default EmptyReportIndicator;
